import styles from "../style/style.module.css";

import { NavLink } from "react-router-dom";
import CompanyLogoFooter from "../assets/global/companyLogo.png";

import { servicesLinks, visGroupLinks } from "../utilities/footerData";
import { navItems } from "../utilities/navBarData";

import DefaultPadding from "../utilities/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faLinkedin,
  faTwitter,
  faReddit,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const padding = new DefaultPadding();
  const defaultPaddingX = padding.getDefaultPaddingX();

  return (
    <section className={`bg-visBlack text-white ${defaultPaddingX}`}>
      <div className="grid grid-cols-1 justify-items-start gap-5 overflow-hidden py-10 font-Inter md:grid-cols-2 lg:grid-cols-4 lg:justify-center">
        <div className="col-span-1 flex w-full justify-start lg:justify-center">
          <div className="h-fit w-fit">
            <NavLink to="/#" className="block w-full">
              <img src={CompanyLogoFooter} alt="logo" />
            </NavLink>
            <p className="py-10 text-start font-normal leading-loose text-gray-300">
              Elevate your digital products and services with our expertise in
              network benchmarking,HMI testing, API testing, software
              development, and mobile network testing. Contact us today to learn
              more!
            </p>
          </div>
        </div>
        <div className="col-span-1 flex w-full justify-start lg:justify-center">
          <div className="h-fit w-fit">
            <h1 className="text-2xl font-bold text-visOrange">Useful Links</h1>
            <nav className="flex flex-col gap-4 py-4">
              {navItems.map((item, index) => {
                return (
                  <NavLink
                    key={item.label + index}
                    className={({ isActive }) =>
                      `text-gray-300 hover:text-white ${isActive && `${styles.textStroke} text-white`}`
                    }
                    to={item.route}
                  >
                    {item.label}
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </div>
        <div className="col-span-1 flex w-full justify-start lg:justify-center">
          <div className="h-fit w-fit">
            <h1 className="text-2xl font-bold text-visOrange">Services</h1>
            <nav className="flex flex-col gap-4 py-4 font-normal">
              {servicesLinks.map((item, index) => {
                return (
                  <NavLink
                    key={item.label + index}
                    to={`/services/detail/${item.href}`}
                    className={({ isActive }) =>
                      `text-gray-300 hover:text-white ${isActive && `${styles.textStroke} text-white`}`
                    }
                  >
                    {item.label}
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </div>
        <div className="col-span-1 flex w-full justify-start lg:justify-center">
          <div className="h-fit w-fit">
            <h1 className="text-2xl font-bold text-visOrange">
              Business Partners
            </h1>
            <nav className="flex flex-col gap-4 py-4 font-normal">
              {visGroupLinks.map((item, index) => {
                return (
                  <NavLink
                    key={item.label + index}
                    to={item.herf}
                    target="_blank"
                    className="text-gray-300 hover:text-white"
                  >
                    {item.label}
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </div>
      </div>
      <hr className="pt-3" />
      <div className="flex w-full flex-wrap items-center justify-between gap-5 py-10">
        <div className="flex items-center gap-8">
          <NavLink
            to="privacypolicy"
            className={({ isActive }) =>
              `text-gray-300 hover:text-white ${isActive && `${styles.textStroke} text-white`}`
            }
          >
            Privacy Policy
          </NavLink>
          <NavLink
            to="/imprint"
            className={({ isActive }) =>
              `text-gray-300 hover:text-white ${isActive && `${styles.textStroke} text-white`}`
            }
          >
            Imprint
          </NavLink>
          <NavLink
            to="/termsandconditions"
            className={({ isActive }) =>
              `text-gray-300 hover:text-white ${isActive && `${styles.textStroke} text-white`}`
            }
          >
            Terms & Conditions
          </NavLink>
        </div>
        <div className="">
          <p>
            Copyright @ 2025{" "}
            <a
              href="https://vis-group.eu/"
              className="text-gray-200 underline hover:text-white"
            >
              Vis-Group
            </a>
          </p>
        </div>
        <div className="flex items-center justify-end gap-3 sm:justify-start lg:justify-end">
          <p>Follow Us</p>
          <a
            href="https://www.facebook.com/SmartElectricalSystems/"
            target="_blank"
          >
            <FontAwesomeIcon
              icon={faFacebook}
              className="cursor-pointer hover:text-[#1877F2]"
              size="xl"
            />
          </a>

          <a
            href="https://www.linkedin.com/company/vision-professional-services-gmbh-i-g-/mycompany/"
            target="_blank"
          >
            <FontAwesomeIcon
              icon={faLinkedin}
              className="cursor-pointer hover:text-[#0077B5]"
              size="xl"
            />
          </a>
          <a href="https://x.com/?lang=en" target="_blank">
            <FontAwesomeIcon
              icon={faTwitter}
              className="cursor-pointer hover:text-[#1DA1F2]"
              size="xl"
            />
          </a>
          {/* <a href="" target="_blank">
            <FontAwesomeIcon
              icon={faReddit}
              className="cursor-pointer hover:text-[#FF4500]"
              size="xl"
            />
          </a> */}
        </div>
      </div>
    </section>
  );
};

export default Footer;
